import api from "PFCore/api";
import { ProfileMinimized } from "PFTypes";

export type FetchChangeRequestsPayload = {
  conversationId: number;
  profileId: number;
  term?: string;
  page?: number;
  perPage?: number;
};

type FetchChangeRequestsResponse = {
  entries: ProfileMinimized[];
  meta: { total: number };
};

export const fetchMentionables = ({
  profileId,
  conversationId,
  term = "",
  page = 1,
  perPage = 50
}: FetchChangeRequestsPayload): Promise<FetchChangeRequestsResponse> =>
  api({
    url: "chat/mentionables",
    params: {
      profileId,
      conversationId,
      term,
      page,
      perPage
    }
  });
